export const isDiscountValidDate = () => {
   const currentDate = new Date();
   let targetDate;
   if (process.env.REACT_APP_PROJECT_COUNTRY === "uk") {
      targetDate = new Date("2025-06-02"); // Example of potentially invalid input YYYY-MM-DD formate
   } else {
      targetDate = new Date("2025-06-02"); // Example of potentially invalid input YYYY-MM-DD formate
   }
   // Check if the target date is valid
   if (isNaN(targetDate.getTime())) {
      console.error("Invalid target date provided!");
      return false; // Return false or handle the error appropriately
   }

   // Only compare dates without time
   const currentDateOnly = new Date(currentDate.toISOString().split('T')[0]);
   const targetDateOnly = new Date(targetDate.toISOString().split('T')[0]);

   // Check if today is on or before the target date
   return currentDateOnly <= targetDateOnly;
};